import { Button } from "../components/ui";
import { assetUrl } from "../lib/assets";
import { trackEvent } from "../lib/analytics";

interface SetupRequiredPageProps {
  appStoreUrl?: string;
  onSignOut: () => void;
}

export function SetupRequiredPage({ appStoreUrl, onSignOut }: SetupRequiredPageProps) {
  const storeUrl = appStoreUrl || "https://apps.apple.com/us/app/pantryrx/id6759058341";

  return (
    <div data-testid="setup-required-page" className="relative min-h-screen overflow-hidden">
      <img src={assetUrl("firstlaunch-texture.png")} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-br from-[color-mix(in_srgb,var(--pr-accent)_20%,#091226)] via-[#0f1d3d] to-[#0a142a]" />

      <div className="relative mx-auto flex min-h-screen w-full max-w-[980px] items-center justify-center px-4 py-10 sm:px-8">
        <section className="w-full max-w-[720px] rounded-[var(--pr-radius-card)] border border-white/20 bg-[#102858e0] p-6 text-white shadow-card backdrop-blur sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <img src={assetUrl("app-icon-logo.png")} alt="PantryRx" className="h-14 w-14 rounded-2xl bg-white/90 p-1" />
            <span className="rounded-full bg-white/20 px-3 py-1 text-xs font-semibold tracking-wide text-white">
              Setup Required
            </span>
          </div>

          <h1 className="pr-display mt-5 text-3xl font-semibold sm:text-4xl">Finish account setup in the iOS app</h1>
          <p className="mt-3 text-base text-white/90 sm:text-lg">
            Your account is signed in, but onboarding and provisioning are completed on iPhone first. Download PantryRx
            from the App Store, finish setup there, then return to web.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <a
              href={storeUrl}
              target="_blank"
              rel="noreferrer"
              className="pr-btn-primary inline-flex min-h-12 items-center justify-center rounded-button px-4 text-sm font-semibold"
              onClick={() => trackEvent("setup_app_store_clicked")}
            >
              Open App Store
            </a>
            <Button
              variant="secondary"
              className="border-white/40 bg-white/10 text-white hover:bg-white/20"
              onClick={() => { trackEvent("setup_sign_out_clicked"); onSignOut(); }}
            >
              Sign out
            </Button>
          </div>

          <p className="mt-4 text-sm text-white/80">
            Web supports viewing and managing your pantry once setup is complete. Credit purchases remain available in
            iOS only.
          </p>
        </section>
      </div>
    </div>
  );
}
